export default "__VITE_PUBLIC_ASSET__756729d9__"